import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export interface ConfirmationPopupConfig {
  header: string;
  message: string;
  acceptButtonLabel: string;
  rejectButtonLabel?: string;
  icon?: string;
  acceptButtonStyleClass?: string;
  rejectButtonStyleClass?: string;
}

@Component({
  selector: 'app-assessment-confirmation-popup',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule
  ],
  templateUrl: './assessment-confirmation-popup.component.html',
  styleUrls: ['./assessment-confirmation-popup.component.scss']
})
export class AssessmentConfirmationPopupComponent {
  @Input() visible: boolean = false;
  @Input() config: ConfirmationPopupConfig | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<boolean>();

  onHide(): void {
    this.visibleChange.emit(false);
  }

  onAccept(): void {
    this.confirmed.emit(true);
    this.visibleChange.emit(false);
  }

  onReject(): void {
    this.confirmed.emit(false);
    this.visibleChange.emit(false);
  }
}
